/**
 * Review Queue API client — Milestone 37.3.
 * Read-only. The queue never mutates state.
 */
import { http } from "@/shared/api/http";
import type { ReviewQueueResponse } from "./types";

export async function fetchReviewQueue(
  workspaceId: string,
  packId: string,
  opts: {
    content_type?: string;
    platform?: string;
    limit?: number;
  } = {},
): Promise<ReviewQueueResponse> {
  const q = new URLSearchParams();
  if (opts.content_type) q.set("content_type", opts.content_type);
  if (opts.platform) q.set("platform", opts.platform);
  if (opts.limit != null) q.set("limit", String(opts.limit));
  const qs = q.toString();
  const suffix = qs ? `?${qs}` : "";
  return http<ReviewQueueResponse>(
    `/workspaces/${workspaceId}/campaign-packs/${packId}/review-queue${suffix}`,
  );
}
